import React from 'react';

import styles from './styles.module.css';

import { Placeholder, PlaceHolderShape } from '@/components/Placeholder';

type Props = {
  className?: string;
};

function UserDetailsPlaceholder({ className }: Props) {
  return (
    <div className={`${className} ${styles.wrapper}`}>
      <div className={styles.avatarWrapper}>
        <Placeholder
          shape={PlaceHolderShape.CIRCLE}
          width="32px"
          height="32px"
        />
      </div>
      <div>
        <Placeholder
          shape={PlaceHolderShape.RECTANGLE}
          width="90px"
          height="18px"
        />
      </div>
    </div>
  );
}

export { UserDetailsPlaceholder };
